import type {
  FeatureFlag,
  FeatureFlagBruta,
  OrigemFuncionalidade,
  SnapshotDisponibilidade,
  SnapshotDisponibilidadeBruto,
} from './acesso.tipos'

export const ORIGENS_FUNCIONALIDADES_LEGADAS = Object.freeze({
  'banco-de-horas': 'legado',
  solicitacoes: 'legado',
} satisfies Record<string, OrigemFuncionalidade>)

const normalizarFlag = (flag: FeatureFlagBruta): FeatureFlag => (
  Object.prototype.hasOwnProperty.call(flag, 'value')
    ? { habilitada: flag.enabled, valor: flag.value }
    : { habilitada: flag.enabled }
)

export const normalizarDisponibilidade = (
  snapshot: SnapshotDisponibilidadeBruto,
): SnapshotDisponibilidade => {
  const modulos = Object.fromEntries(
    Object.entries(snapshot.modulos).map(([slug, valor]) => [slug, Boolean(valor)]),
  )
  const funcionalidades = Object.fromEntries(
    Object.entries(snapshot.funcionalidades).map(([slug, flag]) => [slug, normalizarFlag(flag)]),
  )
  const funcionalidadesLegadas = Object.fromEntries(
    Object.entries(snapshot.funcionalidadesLegadas ?? {}).map(([slug, valor]) => [
      slug,
      { habilitada: valor === true },
    ]),
  )
  const origensFuncionalidades: Record<string, OrigemFuncionalidade> = {
    ...ORIGENS_FUNCIONALIDADES_LEGADAS,
  }

  for (const slug of Object.keys(funcionalidades)) {
    if (!(slug in ORIGENS_FUNCIONALIDADES_LEGADAS)) {
      origensFuncionalidades[slug] = 'flagsmith'
    }
  }

  return {
    modulos,
    funcionalidades,
    funcionalidadesLegadas,
    origensFuncionalidades,
  }
}
